import { enumToLabel } from '.'
import { PaymentMethod, Transaction } from '../../generated'
import { AccountOption } from '../interfaceTypes/common'

export const REFUND_VIA_AUTHORIZE_CARD = 'card-via-authorize'
export const REFUND_VIA_AUTHORIZE_ACH = 'ach-via-authorize'

export const REFUND_PAYMENT_METHODS = [
  PaymentMethod.Cash,
  PaymentMethod.Cheque,
  PaymentMethod.Card,
  PaymentMethod.Ach,
  PaymentMethod.Eft,
  PaymentMethod.WireTransfer,
  PaymentMethod.Other
]

function baseOptions(): AccountOption[] {
  return REFUND_PAYMENT_METHODS.map(method => ({
    value: method,
    label: method === PaymentMethod.Cheque ? 'Check' : enumToLabel(method)
  }))
}

export const refundPaymentMethodOptions = (
  transaction: Pick<Transaction, 'bankData' | 'cardData' | 'transactionId'> | null | undefined
): AccountOption[] => {
  const options = baseOptions()

  if (transaction?.cardData && transaction?.transactionId) {
    options.push({ value: REFUND_VIA_AUTHORIZE_CARD, label: 'Card (via Authorize.net)' })
    return options
  }

  if (transaction?.bankData && transaction?.transactionId) {
    options.push({ value: REFUND_VIA_AUTHORIZE_ACH, label: 'ACH (via Authorize.net)' })
    return options
  }

  return options
}

export function refundPaymentMethodToApi(uiValue: string): PaymentMethod {
  if (uiValue === REFUND_VIA_AUTHORIZE_CARD) return PaymentMethod.Card
  if (uiValue === REFUND_VIA_AUTHORIZE_ACH) return PaymentMethod.Ach
  return uiValue as PaymentMethod
}
